const REACT_APP_PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;

function Schedule({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];
  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }

  return (
    <>
      {data.map((emp) => (
        <div key={emp.id} className="card shadow-none mb-2">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
              <div className="d-flex align-items-start">
                <img
                  src={
                    emp.image
                      ? `${REACT_APP_PINE_BASE_URL}${emp.image}`
                      : "assets/img/users/default.jpg"
                  }
                  className="avatar avatar-lg img-fluid me-3"
                />

                <div>
                  <div className="d-flex align-items-center flex-wrap mb-1">
                    <h6 className="fs-16 fw-semibold mb-0 me-2">
                      {emp.role_name.replace(/&amp;/g, "&")}
                    </h6>
                  </div>
                  <p className="text-muted fs-13 mb-1">
                     {emp.description}
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start">
                <i className="ti ti-calendar fs-16 me-2 text-primary"></i>

                <div>
                    <span className="fs-13 text-muted">
                    {new Date(emp.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })}
                    </span>

                    {emp.time?.trim() && (
                    <div className="fs-13 text-muted">
                        {new Date(`1970-01-01T${emp.time}`).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                            })}
                    </div>
                    )}
                </div>
                </div>
            </div>     
          </div>
        </div>
            ))}
    </>
  );
}

export default Schedule;